var map = {
	"./mi-card.entry.js": [
		"./node_modules/@mapsindoors/components/dist/esm-es5/mi-card.entry.js",
		"stencil-mi-card-entry-js"
	],
	"./mi-column.entry.js": [
		"./node_modules/@mapsindoors/components/dist/esm-es5/mi-column.entry.js",
		"stencil-mi-column-entry-js"
	],
	"./mi-data-table.entry.js": [
		"./node_modules/@mapsindoors/components/dist/esm-es5/mi-data-table.entry.js",
		"stencil-mi-data-table-entry-js"
	],
	"./mi-distance_2.entry.js": [
		"./node_modules/@mapsindoors/components/dist/esm-es5/mi-distance_2.entry.js",
		"stencil-mi-distance_2-entry-js"
	],
	"./mi-dropdown-item.entry.js": [
		"./node_modules/@mapsindoors/components/dist/esm-es5/mi-dropdown-item.entry.js",
		"stencil-mi-dropdown-item-entry-js"
	],
	"./mi-dropdown.entry.js": [
		"./node_modules/@mapsindoors/components/dist/esm-es5/mi-dropdown.entry.js",
		"stencil-mi-dropdown-entry-js"
	],
	"./mi-keyboard.entry.js": [
		"./node_modules/@mapsindoors/components/dist/esm-es5/mi-keyboard.entry.js",
		"stencil-mi-keyboard-entry-js"
	],
	"./mi-list-item-category.entry.js": [
		"./node_modules/@mapsindoors/components/dist/esm-es5/mi-list-item-category.entry.js",
		"stencil-mi-list-item-category-entry-js"
	],
	"./mi-list-item-location.entry.js": [
		"./node_modules/@mapsindoors/components/dist/esm-es5/mi-list-item-location.entry.js",
		"stencil-mi-list-item-location-entry-js"
	],
	"./mi-list.entry.js": [
		"./node_modules/@mapsindoors/components/dist/esm-es5/mi-list.entry.js",
		"stencil-mi-list-entry-js"
	],
	"./mi-location-booking.entry.js": [
		"./node_modules/@mapsindoors/components/dist/esm-es5/mi-location-booking.entry.js",
		"stencil-mi-location-booking-entry-js"
	],
	"./mi-location-info.entry.js": [
		"./node_modules/@mapsindoors/components/dist/esm-es5/mi-location-info.entry.js",
		"stencil-mi-location-info-entry-js"
	],
	"./mi-map-googlemaps.entry.js": [
		"./node_modules/@mapsindoors/components/dist/esm-es5/mi-map-googlemaps.entry.js",
		"stencil-mi-map-googlemaps-entry-js"
	],
	"./mi-map-mapbox.entry.js": [
		"./node_modules/@mapsindoors/components/dist/esm-es5/mi-map-mapbox.entry.js",
		"stencil-mi-map-mapbox-entry-js"
	],
	"./mi-metric-card.entry.js": [
		"./node_modules/@mapsindoors/components/dist/esm-es5/mi-metric-card.entry.js",
		"stencil-mi-metric-card-entry-js"
	],
	"./mi-notification.entry.js": [
		"./node_modules/@mapsindoors/components/dist/esm-es5/mi-notification.entry.js",
		"stencil-mi-notification-entry-js"
	],
	"./mi-route-instructions-heading.entry.js": [
		"./node_modules/@mapsindoors/components/dist/esm-es5/mi-route-instructions-heading.entry.js",
		"stencil-mi-route-instructions-heading-entry-js"
	],
	"./mi-route-instructions-maneuver_2.entry.js": [
		"./node_modules/@mapsindoors/components/dist/esm-es5/mi-route-instructions-maneuver_2.entry.js",
		"stencil-mi-route-instructions-maneuver_2-entry-js"
	],
	"./mi-route-instructions-step.entry.js": [
		"./node_modules/@mapsindoors/components/dist/esm-es5/mi-route-instructions-step.entry.js",
		"stencil-mi-route-instructions-step-entry-js"
	],
	"./mi-route-instructions.entry.js": [
		"./node_modules/@mapsindoors/components/dist/esm-es5/mi-route-instructions.entry.js",
		"stencil-mi-route-instructions-entry-js"
	],
	"./mi-scroll-buttons.entry.js": [
		"./node_modules/@mapsindoors/components/dist/esm-es5/mi-scroll-buttons.entry.js",
		"stencil-mi-scroll-buttons-entry-js"
	],
	"./mi-search.entry.js": [
		"./node_modules/@mapsindoors/components/dist/esm-es5/mi-search.entry.js",
		"stencil-mi-search-entry-js"
	],
	"./mi-share-sms.entry.js": [
		"./node_modules/@mapsindoors/components/dist/esm-es5/mi-share-sms.entry.js",
		"stencil-mi-share-sms-entry-js"
	],
	"./mi-spinner.entry.js": [
		"./node_modules/@mapsindoors/components/dist/esm-es5/mi-spinner.entry.js",
		"stencil-mi-spinner-entry-js"
	],
	"./mi-step-switcher.entry.js": [
		"./node_modules/@mapsindoors/components/dist/esm-es5/mi-step-switcher.entry.js",
		"stencil-mi-step-switcher-entry-js"
	],
	"./mi-tab-panel.entry.js": [
		"./node_modules/@mapsindoors/components/dist/esm-es5/mi-tab-panel.entry.js",
		"stencil-mi-tab-panel-entry-js"
	],
	"./mi-tab.entry.js": [
		"./node_modules/@mapsindoors/components/dist/esm-es5/mi-tab.entry.js",
		"stencil-mi-tab-entry-js"
	],
	"./mi-tabs.entry.js": [
		"./node_modules/@mapsindoors/components/dist/esm-es5/mi-tabs.entry.js",
		"stencil-mi-tabs-entry-js"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./node_modules/@mapsindoors/components/dist/esm-es5 lazy recursive ^\\.\\/.*\\.entry\\.js$ include: \\.entry\\.js$ exclude: \\.system\\.entry\\.js$";
module.exports = webpackAsyncContext;